import { TableHeaderCategoryConfig } from "../../../../components/tables/tableContext/TableContext";
import {
  DestroyedProductsListInterface,
  ProductsRaportsDestroyedInterface,
} from "../../../../redux/interfaces/inventory.interface";
import { dateToString } from "../../../../utils/dateAndTime";

export const productsDestroyedReportsTableHeader: TableHeaderCategoryConfig[] =
  [
    {
      label: "Nr. raport",
      value: "nr_raport",
      minW: 125,
    },

    {
      label: "Utilizator",
      value: "user",
      minW: 125,
      withSearch: {
        placeholder: "Nume utilizator",
      },
    },
    {
      label: "Data creare PV",
      value: "dataPV",
      minW: 125,
      withDatePicker: {
        placeholder: "Data creare PV",
        maxDate: new Date(),
        withClearData: true,
      },
    },
    {
      label: "",
      value: "",
      minW: 125,
    },
    {
      label: "",
      value: "lot",
      minW: 125,
      withSearch: {
        placeholder: "Lot produs",
      },
    },
    {
      label: "",
      value: "productName",
      minW: 50,
      withSearch: {
        placeholder: "Nume produs",
      },
    },
  ];

export const getProductsDestroyedReportsTableData: any = (
  productsDestroyedRaportsListList: ProductsRaportsDestroyedInterface[],
) => {
  const extraHeaderCategories = [
    "",
    "",
    "Nume",
    "Cod grupa",
    "Lot",
    "Cantitate",
    "Motiv",
  ].map((item, idx) => {
    if (idx === 0) {
      return {
        title: "",
      };
    }
    return {
      badges: [
        {
          badgeText: item,
          badgeColor: "secondary",
        },
      ],
    };
  });

  const getExtraDataItems = (products: DestroyedProductsListInterface[]) =>
    products?.map((product) => {
      return [
        {
          title: "",
        },
        {
          title: "",
        },
        {
          title: product.numeProdusErp,
        },
        {
          title: product.codGrupa ? product.codGrupa : "-",
        },
        {
          title: product.lot,
        },
        {
          title: product.cantitate,
        },
        {
          title: product.motiv,
        },
      ];
    });

  return productsDestroyedRaportsListList?.map((item) => {
    return {
      id: item.nr_raport,
      crudData: item,
      extraData: [extraHeaderCategories, ...getExtraDataItems(item.products)],

      data: [
        {
          title: item.nr_raport,
        },
        {
          title: item.userName,
        },
        {
          title: dateToString(item.dataPV),
        },
        {
          title: "",
        },
        {
          title: "",
        },
        {
          title: "",
        },
      ],
    };
  });
};
